import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { PrimaryHoverOutlinedInput } from './PrimaryHoverOutlinedInput.styles';
import { SecondaryHoverButton } from './SecondaryHoverButton.styles';
import { useLoginViewController } from '../../controllers';

export const LoginView = () => {
  const {
    applicationSettings,
    signupOffered,
    formValues,
    errors,
    showPassword,
    handleClickShowPassword,
    handleMouseDownPassword,
    handleChange,
    handleLogin,
    onKeyDown,
    navigateToForgotPassword,
  } = useLoginViewController();

  if (!applicationSettings) {
    return null;
  }

  return (
    <Stack direction="row" width="100%" height="100vh" alignItems="center" justifyContent="center">
      <Stack width={400} p={5} justifyContent="center">
        <Typography
          variant="h4"
          component="div"
          fontWeight="fontWeightSemiBold"
          mb={5}
          textAlign="center"
        >
          Welcome to {applicationSettings.name}
        </Typography>
        <TextField
          error={!!errors?.email}
          id="outlined-basic"
          label="Email Address"
          variant="outlined"
          type="email"
          inputMode="email"
          autoComplete="email"
          value={formValues.email}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          name="email"
        />
        <FormControl variant="outlined" sx={{ my: 2.25 }}>
          <InputLabel htmlFor="outlined-adornment-password" error={!!errors?.password}>
            Password
          </InputLabel>
          <PrimaryHoverOutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            value={formValues.password}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            name="password"
            error={!!errors?.password}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
          <FormHelperText id="component-error-text" error>
            {errors.password || ''}
          </FormHelperText>
          <FormHelperText id="component-error-text" error>
            {errors.validation || ''}
          </FormHelperText>
        </FormControl>
        <Link
          component="button"
          variant="body2"
          onClick={navigateToForgotPassword}
          mb={3}
          textAlign="right"
        >
          Forgot Password?
        </Link>
        <SecondaryHoverButton type="submit" variant="contained" size="large" onClick={handleLogin}>
          Login
        </SecondaryHoverButton>
        {signupOffered && (
          <Typography variant="body2" color="text.secondary" textAlign="center" mt={3}>
            {"Don't have an account?"}{' '}
            <Link component={RouterLink} to="/signup">
              Sign up
            </Link>
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
